import React, {useState} from "react";
import {Box, Button, Input, Modal, Typography} from "@mui/material";
import {ClosePopupBtn} from "../../../../../../../com/closePopupBtn/closePopupBtn";
import {makeStyles} from "@mui/styles";
import {FlyerClassDto} from "../../../../../../../dtos";
import {createFlyerClass, updateFlyerClass} from "../../../../../../../store/actionCreators/flyerClassesActionCreators";
import {useDispatch} from "react-redux";

const useStyles = makeStyles(() => ({
    createEditFlyerClassPopupWrap: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "20vw",
        minWidth: "322px",
        backgroundColor: "white",
        display: "flex",
        flexFlow: "column"
    },
    createEditFlyerClassHeader: {
        position: "relative",
        padding: `12px 20px`,
        background: `linear-gradient(89.41deg, #0198D2 0%, #3540A8 100%)`,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        "& .MuiButton-root": {
            "& > svg": {
                "& > path": {
                    fill: `#ffffff`,
                },
            },
        },
    },

    actionBtn: {
        width: "50%",
        '&.MuiButton-root': {
            padding: `10px 20px`,
            textTransform: `inherit`,
            border: `1px solid #014780`,
        },
        '&.Mui-disabled': {
            opacity: `0.5`,
        },
        '& > .MuiTypography-root': {
            lineHeight: `18px`,
            fontWeight: `700`
        }
    },
    mainBtn: {
        // width: `100%`,
        '&.MuiButton-root': {
            backgroundColor: `#014780`,
            "&:hover": {
                backgroundColor: `#01478080`,
            }
        },
        '& > .MuiTypography-root': {
            color: `#ffffff`,
        }
    },
    secondaryBtn: {
        // width: `100%`,
        background: `#ffffff`,
        '& > .MuiTypography-root': {
            color: `#014780`,
        }
    },
}));

interface Props {
    show: boolean;
    isNew: boolean;
    flyerClassData: FlyerClassDto;
    hide: VoidFunction;
}

export const CreateEditFlyerClassPopup: React.FC<Props> = ({
                                                               show,
                                                               isNew,
                                                               flyerClassData,
                                                               hide
                                                           }) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [flyerClassState, setFlyerClassState] = useState<FlyerClassDto>(flyerClassData);

    const onChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const value = e.target.value;
        setFlyerClassState({
            ...flyerClassState,
            caption: value
        });
    }

    const compareDefaultPromoStateWithCurrentPromoState = (): boolean => {
        const stringDefaultState = JSON.stringify(flyerClassData);
        const stringCurrentState = JSON.stringify(flyerClassState);
        return stringDefaultState !== stringCurrentState;
    }

    const onSave = () => {
        if(isNew){
            dispatch(createFlyerClass([flyerClassState.caption]));
        } else {
            dispatch(updateFlyerClass([flyerClassState]));
        }
        hide();
    }

    return (
        <Modal open={show}>
            <form onSubmit={onSave}>
                <Box className={classes.createEditFlyerClassPopupWrap}>
                    <Box
                        className={classes.createEditFlyerClassHeader}
                    >
                        <Box>
                            <Typography color={`#ffffff`} fontWeight={700}>
                                {isNew ? "Create Class" : "Edit Class"}
                            </Typography>
                        </Box>
                        <Box sx={{
                            display: `flex`,
                            justifyContent: `flex-end`,
                            position: "absolute",
                            top: "50%",
                            right: "5px",
                            transform: "translateY(-50%)"
                        }}>
                            <ClosePopupBtn onClose={hide}/>
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            flexFlow: "row",
                            columnGap: "12px",
                            padding: "24px 12px"
                        }}
                    >
                        <Typography>
                            Class:
                        </Typography>
                        <Input
                            autoFocus
                            disableUnderline
                            value={flyerClassState.caption}
                            onChange={onChange}
                            sx={{
                                border: "1px solid #888888",
                                flex: "1 1 auto",
                                borderRadius: "5px",
                                padding: "0 4px"
                            }}
                        />
                    </Box>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            flexFlow: "row",
                            columnGap: "12px",
                            padding: "12px"
                        }}
                    >
                        <Button
                            onClick={hide}
                            className={`${classes.secondaryBtn} ${classes.actionBtn}`}>
                            <Typography>
                                Cancel
                            </Typography>
                        </Button>
                        <Button
                            type={"submit"}
                            disabled={!compareDefaultPromoStateWithCurrentPromoState()}
                            className={`${classes.mainBtn} ${classes.actionBtn}`}
                        >
                            <Typography>
                                Save
                            </Typography>
                        </Button>
                    </Box>
                </Box>
            </form>
        </Modal>
    )
}